import * as THREE from 'three'
import { EXRLoader } from 'three/addons/loaders/EXRLoader.js'

export class SceneManager {
  constructor(canvas) {
    this.canvas = canvas
    this.scene = new THREE.Scene()

    // Fog for tunnel effect (disabled)
    // this.scene.fog = new THREE.FogExp2(0x000000, 0.03)
    this.scene.background = new THREE.Color(0x000000)

    // Renderer
    this.renderer = new THREE.WebGLRenderer({
      canvas: this.canvas,
      antialias: false
    })
    this.renderer.setSize(window.innerWidth, window.innerHeight)
    // Cap pixel ratio to reduce fill-rate burden on high-DPI screens
    this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 1.5))

    // Correct colour space & tone mapping for HDR display
    this.renderer.outputColorSpace = THREE.SRGBColorSpace
    // this.renderer.toneMapping = THREE.ACESFilmicToneMapping
    // this.renderer.toneMappingExposure = 1.0

    // Lighting
    this.ambientLight = new THREE.AmbientLight(0xffffff, 0.5)
    this.scene.add(this.ambientLight)

    this.directionalLight = new THREE.DirectionalLight(0xffffff, 1)
    this.directionalLight.position.set(5, 10, 7)
    this.scene.add(this.directionalLight)

    // Load HDRI environment map
    this.loadHDRI()

    // Resize handler
    window.addEventListener('resize', this.onResize.bind(this))
  }

  loadHDRI() {
    const pmremGenerator = new THREE.PMREMGenerator(this.renderer)
    pmremGenerator.compileEquirectangularShader()

    new EXRLoader()
      .load('./forest.exr', (texture) => {
        texture.mapping = THREE.EquirectangularReflectionMapping

        // EXR contains linear HDR data — PMREMGenerator builds the env map
        const pmremTexture = pmremGenerator.fromEquirectangular(texture).texture

        this.scene.environment = pmremTexture
        this.scene.environmentIntensity = 0.5

        pmremGenerator.dispose()
        texture.dispose()
      }, undefined, (error) => {
        console.error('Failed to load HDRI:', error)
      })
  }

  onResize() {
    this.renderer.setSize(window.innerWidth, window.innerHeight)
    this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
  }

  render(camera) {
    this.renderer.render(this.scene, camera)
  }

  add(object) {
    this.scene.add(object)
  }

  remove(object) {
    this.scene.remove(object)
  }
}
